package dev.lingvo.ops.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import dev.lingvo.ops.api.OpsApi
import dev.lingvo.ops.state.OpsCallbackIntent
import dev.lingvo.ops.state.OpsCallbackState
import dev.lingvo.ops.state.OpsCallbackStore
import dev.lingvo.site.api.Session
import dev.lingvo.site.api.SessionRequestIdentity
import dev.lingvo.site.ds.LAlert
import dev.lingvo.site.ds.LAlertVariant
import dev.lingvo.site.ds.LButton
import dev.lingvo.site.ds.LSkeleton
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.css.px

@Page("/auth/callback")
@Composable
fun OpsAuthCallbackPage() {
    val ctx = rememberPageContext()
    val scope = rememberCoroutineScope()
    val code = remember { ctx.route.queryParams["code"].orEmpty() }
    val store = remember {
        var attemptedIdentity: SessionRequestIdentity? = null
        OpsCallbackStore(
            scope = scope,
            removeCodeFromHistory = {
                window.history.replaceState(window.history.state, "", window.location.pathname)
                document.title = "Signing in · Lingvo operator console"
            },
            exchangeAndCheck = { exchangeCode ->
                Session.adoptOAuthSession(exchangeCode)
                check(Session.isAuthenticated)
                attemptedIdentity = Session.requestIdentity
                OpsApi.me()
                check(Session.requestIdentity == attemptedIdentity) { "Session replaced" }
            },
            clearAttemptedSession = {
                // A late failure must not sign out a newer authenticated session.
                if (Session.requestIdentity == attemptedIdentity) Session.logout()
            },
            onComplete = { ctx.router.tryRoutingTo("/", UpdateHistoryMode.REPLACE) },
            onReturnToLogin = { ctx.router.tryRoutingTo("/login", UpdateHistoryMode.REPLACE) },
        )
    }
    DisposableEffect(store) { onDispose { store.dispose() } }
    LaunchedEffect(store) { store.accept(OpsCallbackIntent.Start(code)) }
    val failure = store.state as? OpsCallbackState.Failed
    OpsAuthSurface(if (failure == null) "Signing in" else "Sign-in failed",
        "Checking your session and operator access before opening the console.") {
        if (failure == null) {
            LSkeleton(height = 40.px, shimmer = false)
        } else {
            LAlert("Could not sign in", failure.message, variant = LAlertVariant.DANGER, live = true)
            LButton("Back to sign in", { store.accept(OpsCallbackIntent.ReturnToLogin) })
        }
    }
}
